import { lazyBackground, lazyLoadImage } from "../utils/utils";

export default class SidebarLinks {
	constructor(el) {

		this.page = el;
		this.pageSections = el.querySelectorAll('section');
		this.observeSection = this.observeSection.bind(this);
		this.sidebarLinks = document.querySelectorAll('[data-component="sidebar"] a')

		this.config = {
			rootMargin: "-45% 0px -45% 0px",
			threshold: 0,
		};

		this.observer = new IntersectionObserver((entries, self) => {
			entries.forEach((entry) => {
				this.observeSection(entry)
			});
		}, this.config);

		this.pageSections.forEach((section) => {
			this.observer.observe(section);
		});

	}
	observeSection(entry) {
		let currentAnchorLink = document.querySelector(`[href$='#${entry.target.id}']`)
		if (entry.isIntersecting) {
			this.sidebarLinks.forEach( (link) =>
			{
				link.classList.remove('active');
			})
			
			if( currentAnchorLink ){
				currentAnchorLink.classList.add('active')
			}
			entry.target.classList.add("loaded");
		} else {
			if( currentAnchorLink ){
				currentAnchorLink.classList.remove('active')
			}
		}
	}
}
